import { useContext } from "react";
import { DefaultPageLayoutContext } from "../components/context/default-page-layout-context";
export var useDefaultPageLayout = function useDefaultPageLayout() {
  return useContext(DefaultPageLayoutContext) || function () {
    return null;
  };
};